// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__4LFXR","alertText":"Alert_alertText__aNaKT","alertIcon":"Alert_alertIcon__HBRKi"};